<sdx-footer
  social-media='[{"href":"https://www.linkedin.com/company/swisscom-health","iconName":"icon-linkedin"}]'
  [legals]="[
    { label: ('footer.label_contact' | translate), href: 'mailto:support.health@swisscom.com' },
    {
      label: ('footer.label_imprint' | translate),
      href: 'https://www.swisscom.ch/en/business/footer/impressum.html'
    }
  ]">
</sdx-footer>
